import React, { useContext, useState } from "react";
import Box from "@mui/material/Box";
import { gql, useApolloClient } from "@apollo/client";
import { Route } from "react-router-dom";
import { useHistory } from "react-router-dom";
import Footer from "./footer";
import Header from "./header";
import ModalIdContext from "../contexts/modal-id-context";
import { isLoggedInVar } from './app/app';

const InternalLayout = ({ component: Component, modal, ...rest }) => {
  const client = useApolloClient();
  const [headerTitle, setHeaderTitle] = useState('');
  const [showEntryList, setShowEntryList] = useState(true);
  const [showHeart, setShowHeart] = useState(false);
  const [entryId, setEntryId] = useState(null);
  const history = useHistory();

  const handleLogOut = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user_id");

    client.cache.writeQuery({
      query: gql`
        query GetLoggedInStatus {
          isLoggedIn
        }
      `,
      data: { isLoggedIn: false },
    });
    isLoggedInVar(false);
    history.push("/");
  };
  
  const modelId = useContext(ModalIdContext);
  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <Box name="AppWrapper">
          <Header 
            title={headerTitle} 
            handleLogOut={handleLogOut} 
            showHeart={showHeart} 
            entryId={entryId}
            setShowEntryList={setShowEntryList}
            showEntryList={showEntryList}
          />
          <Component 
            setHeaderTitle={setHeaderTitle} 
            {...matchProps} 
            setShowHeart={setShowHeart} 
            setEntryId={setEntryId} 
            setShowEntryList={setShowEntryList}
            showEntryList={showEntryList}
          />
          <Footer />
          <ModalIdContext.Provider>
            <div id={modelId}></div>
          </ModalIdContext.Provider>
        </Box>
      )}
    />
  );
};

export default InternalLayout;
